import { startRequest, finishRequest } from "@store/utils";

export const onUpdateSlaPerformanceSectionsToggle = (state: Object) => (data: Object) => {
  return {
    ...state,
    slaPerformance: {
      ...state.slaPerformance,
      sectionsToggle: {
        ...state.slaPerformance.sectionsToggle,
        [data.payload]: !state.slaPerformance.sectionsToggle[data.payload],
      },
    },
  };
};

export const onUpdateSlaPerformanceScopeAndFilters = (state: Object) => (data: Object) => {
  return {
    ...state,
    slaPerformance: {
      ...state.slaPerformance,
      areas: {
        ...state.slaPerformance.areas,
        ...data.payload,
      },
    },
  };
};
export const onResetSlaPerformanceScopeAndFilters = (state: Object) => (data: Object) => {
  return {
    ...state,
    slaPerformance: {
      ...state.slaPerformance,
      charts: [],
      report: [],
      areas: {
        selected: [],
        excluded: [],
      },
    },
  };
};

export const onGetSlaPerformanceReportDetails = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    slaPerformance: {
      ...startRequest(state.slaPerformance),
    },
  };
};

export const onGetSlaPerformanceReportDetailsSuccess = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    slaPerformance: {
      ...finishRequest(state.slaPerformance),
      ...payload.data,
    },
  };
};
export const onGetSlaPerformanceReportDetailsError = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    slaPerformance: {
      ...finishRequest(state.slaPerformance),
    },
  };
};

export const onExportSlaPerformanceReport = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    slaPerformance: {
      ...startRequest(state.slaPerformance),
    },
  };
};

export const onExportSlaPerformanceReportSuccess = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    slaPerformance: {
      ...finishRequest(state.slaPerformance),
    },
  };
};
export const onExportSlaPerformanceReportError = (state: Object) => ({ payload }: Object) => {
  return {
    ...state,
    slaPerformance: {
      ...finishRequest(state.slaPerformance),
    },
  };
};
